import { useEffect } from 'react';

/**
 * Locks <body> scroll while `isOpen` is true and restores the previous
 * overflow / paddingRight on close. Tracks open count globally so that
 * multiple modals open at once still correctly release the lock only
 * after the last one closes.
 *
 * Adds paddingRight equal to the scrollbar width to prevent the layout
 * "jump" that happens when the scrollbar disappears.
 */
let openCount = 0;
let originalOverflow = '';
let originalPaddingRight = '';

const useBodyScrollLock = (isOpen) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    if (openCount === 0) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      originalOverflow = document.body.style.overflow;
      originalPaddingRight = document.body.style.paddingRight;
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }
    openCount += 1;

    return () => {
      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) {
        document.body.style.overflow = originalOverflow;
        document.body.style.paddingRight = originalPaddingRight;
      }
    };
  }, [isOpen]);
};

export default useBodyScrollLock;
